import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import IconSelector from "../images/IconSelector";

const EmptyList = ({
 noCreation,
 showPaper = true
}: {
 noCreation?: boolean;
 showPaper?: boolean;
}): ReactElement => {
 return (
  <Paper
   elevation={showPaper ? 1 : 0}
   sx={{
    minHeight: 100,
    borderRadius: "5px",
    boxShadow: showPaper ? "0 3px 6px #00000029" : "none"
   }}>
   <Stack justifyContent="center" alignItems="center" p={3} spacing={2}>
    <IconSelector icon="EmptyIcon" props={{ color: "error", sx: { fontSize: 40 } }} />
    <Typography variant="subtitle2">
     <FormattedMessage id={noCreation ? "app.noElementInListNoCreation" : "app.noElementInList"} />
    </Typography>
   </Stack>
  </Paper>
 );
};

export default EmptyList;
